export default __webpack_public_path__ + "static/sorting-264446f0baf4d0fe43a88c76fe6366f6.webp";